module.exports = __webpack_public_path__ + "b1c79e87ff0ac2d63d289125fcba1f79.ico";